
import { Link } from 'react-router-dom'

const ContentType = ({contentType, language}) => {
    let publishScheduleDate = ""
    if(contentType.published){
        var pd = new Date(contentType.publishDate)
        publishScheduleDate = pd.toLocaleString()
    }
    if(contentType.scheduleDate !== "1970-01-01T00:00:00"){
        var sd = new Date(contentType.scheduleDate)
        publishScheduleDate = sd.toLocaleString()
    }
    return (
        <label key={contentType.id} className="list-item" data-id={contentType.contentTypeId} data-articlename="Tekstboks" data-articletype="Text" data-published="0">
            <span className="checkbox-container"><input type="checkbox" name="articleid" value="" /></span>
            <span className="name-container">{contentType.contentTypeName}</span>
            <span className="type-container">{contentType.contentModel.modelName}</span>
            <span className="published-container">
                <span>{language.value === "DA" ? 
                    (contentType.published ? "Offentliggjort" + (contentType.isDraft ? " [kladde]" : "") : "Kladde") : 
                    (contentType.published ? "Published" + (contentType.isDraft ? " [draft]" : "") : "Draft")
                }</span>
                <small>
                    {publishScheduleDate}
                </small>
            </span>
            <span className="edit-container">
                <Link to={`/content/${contentType.id}`} >
                    <i className="sprite-icon icon-arrow-next"></i>
                </Link>
            </span>
        </label>
    )
}

export default ContentType
